import React from 'react'

import clsx from 'clsx'

import ScoreGauge0 from '$extensionSrc/icons/impact-metrics-score-gauge-0.svg'
import ScoreGauge10 from '$extensionSrc/icons/impact-metrics-score-gauge-10.svg'
import ScoreGauge100 from '$extensionSrc/icons/impact-metrics-score-gauge-100.svg'
import ScoreGauge20 from '$extensionSrc/icons/impact-metrics-score-gauge-20.svg'
import ScoreGauge30 from '$extensionSrc/icons/impact-metrics-score-gauge-30.svg'
import ScoreGauge40 from '$extensionSrc/icons/impact-metrics-score-gauge-40.svg'
import ScoreGauge50 from '$extensionSrc/icons/impact-metrics-score-gauge-50.svg'
import ScoreGauge60 from '$extensionSrc/icons/impact-metrics-score-gauge-60.svg'
import ScoreGauge70 from '$extensionSrc/icons/impact-metrics-score-gauge-70.svg'
import ScoreGauge80 from '$extensionSrc/icons/impact-metrics-score-gauge-80.svg'
import ScoreGauge90 from '$extensionSrc/icons/impact-metrics-score-gauge-90.svg'

import styles from './ScoreGauge.module.scss'

type ScoreLevel = 0 | 10 | 20 | 30 | 40 | 50 | 60 | 70 | 80 | 90 | 100

function getIconForScore(
  score: number,
): React.FC<React.SVGProps<SVGSVGElement>> {
  let quantizedScore: ScoreLevel
  if (score < 0.1) {
    quantizedScore = 0
  } else if (score < 10) {
    quantizedScore = 10
  } else if (score > 99.9) {
    quantizedScore = 100
  } else {
    quantizedScore = (score - (score % 10)) as ScoreLevel
  }

  const mapScoreToIcon: Record<
    ScoreLevel,
    React.FC<React.SVGProps<SVGSVGElement>>
  > = {
    0: ScoreGauge0,
    10: ScoreGauge10,
    20: ScoreGauge20,
    30: ScoreGauge30,
    40: ScoreGauge40,
    50: ScoreGauge50,
    60: ScoreGauge60,
    70: ScoreGauge70,
    80: ScoreGauge80,
    90: ScoreGauge90,
    100: ScoreGauge100,
  }

  return mapScoreToIcon[quantizedScore]
}

/**
 * Note: background color can be set by manipulating a CSS class added to each
 * of the icons; to modify the class, change both the ScoreGauge.module.scss file
 * as well as each of the icon SVG files.
 */
export default function ScoreGauge({
  score,
  backgroundColor,
}: {
  score: number
  backgroundColor?: 'lighterGray' | 'darkBlue'
}) {
  if (score === null || score === undefined) {
    return null
  }

  const Icon = getIconForScore(score * 100)

  return (
    <Icon
      aria-hidden
      className={clsx(
        'ScoreGauge',
        backgroundColor ? styles[backgroundColor] : styles.lighterGray,
      )}
    />
  )
}
